import styled from "styled-components";
import { responsive } from "../../../../../../styles/constants.style";

export const NISStatusResultWrapper = styled.div`
  margin: 19px 0px 39px 0px;
  ${responsive.MOBILE`
    margin: 16px 0px 0px 0px;   
  `}

  .MuiPickersTextField-root,
  .MuiPickersInputBase-root {
    width: 100%;
  }

  .cell-created-date {
    min-width: 250px;
  }
  .cell-status {
    min-width: 200px;
  }
  .cell-createdBy {
    min-width: 225px;
  }
  .cell-notes {
    min-width: 300px;
  }
`;
